import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><defs><style></style></defs><path d=\"M837.8 389.8V104.7H674.9v122.2L512 64 64 512h81.5v448h244.4V593.5h244.4V960h244.4V512H960L837.8 389.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol